export const DOGE = () => (
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
      fill="white"
    />
    <path
      d="M16.384 10.5441H14.0979V15.0511H17.6945V16.9381H14.0979V21.4449H16.496C17.1121 21.4449 21.5545 21.5145 21.5477 16.2013C21.5408 10.8882 17.239 10.5441 16.384 10.5441Z"
      fill="#C2A633"
    />
    <path
      d="M16 0C7.16336 0 0 7.16336 0 16C0 24.8366 7.16336 32 16 32C24.8366 32 32 24.8366 32 16C32 7.16336 24.8366 0 16 0ZM16.6286 24.6416H10.8342V16.9382H8.79168V15.0512H10.8341V7.34736H15.8072C16.9837 7.34736 24.7762 7.10304 24.7762 16.139C24.7762 25.3245 16.6288 24.6416 16.6288 24.6416H16.6286Z"
      fill="#C2A633"
    />
  </svg>
);
